export function getRoundedNumber(input: number): number {
	if (input === 0) return 0;

	const roundedInput = Math.round(input * 100) / 100;

	return roundedInput;
}
